/*
    ROUTER.JS

    - Last updated: 17.10.18
    - NOTES:
		https://medium.com/@anas.mammeri/vue-2-firebase-how-to-build-a-vue-app-with-firebase-authentication-system-in-15-minutes-fdce6f289c3c
		https://github.com/vuejs/vue-router/issues/1753
		http://jsfiddle.net/L7hscd8h/9377/
		https://forum.vuejs.org/t/vue-router-uncaught-error-during-route-navigation/41913/3

		// --
		// EG: component: () => import('@/views/Home.vue')
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		// --
*/

import Vue from 'vue';
import Router from 'vue-router';
import firebase from '@/config/firebase';

import SignUp from '@/views/auth/SignUp';
import Login from '@/views/auth/Login';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '*',
			redirect: '/login/'
		},
		{
			path: '/login/',
			name: 'login',
			component: Login,
			meta: { name: 'Login' },
			// alias: ['/'],
			pathToRegexpOptions: { strict: true }
		},
		{
			path: '/sign-up/',
			name: 'sign-up',
			component: SignUp,
			meta: 'Sign Up'
		},
		{
			path: '/start/',
			name: 'Lobby',
			// component: Chapter01,
			component: () => import(/* webpackChunkName: "lobby" */ '@/views/Chapter01.vue'),
			meta: { name: 'Lobby', requiresAuth: true },
			pathToRegexpOptions: { strict: true }
		},
		{
			path: '/chapter-02/',
			name: 'Chapter 2',
			component: () => import(/* webpackChunkName: "chapter2" */ '@/views/Chapter02.vue'),
			meta: { name: 'chapter2', requiresAuth: true },
		},
	]
});

router.beforeEach((to, from, next) => {
	// eslint-disable-next-line
	let currentUser = firebase.auth().currentUser;
	// eslint-disable-next-line
	let requiresAuth = to.matched.some(record => record.meta.requiresAuth);

	next(); // comment this out

	// if (requiresAuth && !currentUser) {
	// 	next('/login/');
	// } else if (!requiresAuth && currentUser) {
	// 	next('/start/');
	// } else {
	// 	next();
	// }
});

// router.afterEach(route => {
// 	document.title = route.meta;
// });

export default router;